@if (categoryId) {
  <app-view-category-details [categoryId]="categoryId" />
}
